/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Fit_DescInputs */

const en_ui_onboarding_fit_desc = /** @type {(inputs: Ui_Onboarding_Fit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garmin, Wahoo, Zwift & co. — or a .zip`)
};

const de_ui_onboarding_fit_desc = /** @type {(inputs: Ui_Onboarding_Fit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garmin, Wahoo, Zwift & Co. – oder .zip`)
};

/**
* | output |
* | --- |
* | "Garmin, Wahoo, Zwift & co. — or a .zip" |
*
* @param {Ui_Onboarding_Fit_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_fit_desc = /** @type {((inputs?: Ui_Onboarding_Fit_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Fit_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_fit_desc(inputs)
	return de_ui_onboarding_fit_desc(inputs)
});